import type { HistoryEntity } from '@repo/features/history'

export const companyHistoryEntity: HistoryEntity = {
  eventLabels: {
    bank_account_added: 'Bank account added',
    bank_account_removed: 'Bank account removed',
    contact_added: 'Contact added',
    contact_removed: 'Contact removed',
  },
  name: 'Company',
  // Subject types are the API's model names; Shipper and Haulier read as Customer and Carrier.
  subjectLabels: {
    CompanyAddress: 'Address',
    CompanyBankAccount: 'Bank account',
    CompanyContact: 'Contact',
    CompanyDocument: 'Document',
    CustomerRiskProfile: 'Risk profile',
    Haulier: 'Carrier profile',
    Location: 'Location',
    Shipper: 'Customer profile',
  },
}
